var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0",
      attrs: { id: "annonce-create-step-right-part" }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { id: "annonce-create-step-right-part-inside" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-5" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.insurance.company"),
                    "label-for": "insuranceCompany-input"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "insuranceCompany-input",
                      state: _vm.insuranceCompany.state
                    },
                    on: { change: _vm.setAnnonce },
                    model: {
                      value: _vm.insuranceCompany.value,
                      callback: function($$v) {
                        _vm.$set(_vm.insuranceCompany, "value", $$v)
                      },
                      expression: "insuranceCompany.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-5" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.insurance.contract"),
                    "label-for": "insuranceContract-input"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "insuranceContract-input",
                      state: _vm.insuranceContract.state
                    },
                    on: { change: _vm.setAnnonce },
                    model: {
                      value: _vm.insuranceContract.value,
                      callback: function($$v) {
                        _vm.$set(_vm.insuranceContract, "value", $$v)
                      },
                      expression: "insuranceContract.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLicensed
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-5" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text form-group-with-label-legend",
                      attrs: {
                        "invalid-feedback": _vm.carteGriseFile.invalidFeedback,
                        label: _vm.$t("annonce.vehicle.carteGrise"),
                        state: _vm.carteGriseFile.state,
                        "label-for": "carteGriseFile-input"
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "label-legend-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("annonce.online.mandatory.field")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("b-form-file", {
                        ref: "carteGriseFile-input",
                        attrs: {
                          id: "carteGriseFile-input",
                          "browse-text": _vm.$t("Select"),
                          "drop-placeholder": _vm.$t("drop-placeholder"),
                          placeholder: _vm.carteGriseFile.fileName,
                          accept: ".png, .jpeg, .jpg, .pdf",
                          required: ""
                        },
                        on: {
                          change: function(event) {
                            return _vm.previewImage(event, "carteGriseFile")
                          },
                          input: function($event) {
                            return _vm.setAnnonce($event, "carteGriseFile")
                          }
                        },
                        model: {
                          value: _vm.carteGriseFile.value,
                          callback: function($$v) {
                            _vm.$set(_vm.carteGriseFile, "value", $$v)
                          },
                          expression: "carteGriseFile.value"
                        }
                      }),
                      _vm._v(" "),
                      _c("PreviewOneFile", {
                        attrs: {
                          file: _vm.carteGriseFile,
                          imagePreviewSrc: _vm.imagePreviewCarteGriseFile,
                          pdfPreviewSrc: _vm.pdfPreviewCarteGriseFile,
                          fileId: "carteGriseFile"
                        },
                        on: { deleteFileInPreview: _vm.deleteFileFromPreview }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-5" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text form-group-with-label-legend",
                  attrs: {
                    "invalid-feedback": _vm.plainteFile.invalidFeedback,
                    label: _vm.$t("annonce.depotPlainte"),
                    state: _vm.plainteFile.state,
                    "label-for": "plainteFile-input"
                  }
                },
                [
                  _c("div", {
                    staticClass: "label-legend-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("annonce.online.mandatory.field")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("b-form-file", {
                    ref: "plainteFile-input",
                    attrs: {
                      id: "plainteFile-input",
                      "browse-text": _vm.$t("Select"),
                      "drop-placeholder": _vm.$t("drop-placeholder"),
                      placeholder: _vm.plainteFile.fileName,
                      accept: ".png, .jpeg, .jpg, .pdf",
                      required: ""
                    },
                    on: {
                      change: function(event) {
                        return _vm.previewImage(event, "plainteFile")
                      },
                      input: function($event) {
                        return _vm.setAnnonce($event, "plainteFile")
                      }
                    },
                    model: {
                      value: _vm.plainteFile.value,
                      callback: function($$v) {
                        _vm.$set(_vm.plainteFile, "value", $$v)
                      },
                      expression: "plainteFile.value"
                    }
                  }),
                  _vm._v(" "),
                  _c("PreviewOneFile", {
                    attrs: {
                      file: _vm.plainteFile,
                      imagePreviewSrc: _vm.imagePreviewPlainteFile,
                      pdfPreviewSrc: _vm.pdfPreviewPlainteFile,
                      fileId: "plainteFile"
                    },
                    on: { deleteFileInPreview: _vm.deleteFileFromPreview }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pl-0 pr-0 mb-2" }, [
            _c("span", {
              staticClass: "custom-span-files-mandatory",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    _vm.isLicensed
                      ? "annonce.files.mandatory.licensed"
                      : "annonce.files.mandatory.not.licensed"
                  )
                )
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-646a01a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-646a01a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateStep7.vue
// module id = up+r
// module chunks = 0